import { EthersError } from '@enzoferey/ethers-error-parser';

import { AppDispatch } from '../store';
import { setBuildTxError } from '../store/state/swap/swapSlice';

/**
 * @function
 * @description Checks whether a value is an instance of EthersError.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns true if the value is an instance of EthersError, otherwise false.
 */
export function isEthersError(value: any): value is EthersError {
  return typeof value === 'object' && value !== null && 'code' in value && 'error' in value && 'reason' in value;
}

/**
 * @function
 * @description Handles an error that occurred while building a transaction and dispatches the error information to the Redux store.
 * @param {EthersError} err - The error that occurred while building the transaction.
 * @param {AppDispatch} dispatch - The dispatch function provided by the Redux store.
 * @returns {void}
 */
export const handleBuildTxError = (err: EthersError, dispatch: AppDispatch): void => {
  if (!isEthersError(err)) {
    throw new Error('Invalid argument: err must be an instance of EthersError');
  }
  if (typeof dispatch !== 'function') {
    throw new Error('Invalid parameter: "dispatch" must be a function.');
  }
  const { code, error, reason } = err;
  dispatch(setBuildTxError({ code, error, reason }));
};
